export default __webpack_public_path__ + "static/media/bq.c4696c0a.svg";